var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import Button from 'syf-component-library/ui/atoms/Button';
import RenderIf from 'syf-component-library/ui/atoms/RenderIf';
import Inset from 'syf-component-library/ui/spacing/Inset';
import Stack from 'syf-component-library/ui/spacing/Stack';
import { StyledText, StyledTitle } from '../../../../ui/subcomponents';
import { PaymentOptionCard } from './subcomponents';
import { getButtonAnalytics } from '../../../../helpers/getAnalytics';
var OptionCard = function (_a) {
    var button = _a.button, heading = _a.heading, isActive = _a.isActive, onClick = _a.onClick, text = _a.text;
    var buttonAnalytics = getButtonAnalytics(heading);
    return (_jsx(RenderIf, __assign({ condition: isActive }, { children: _jsxs(_Fragment, { children: [_jsx(PaymentOptionCard, { children: _jsxs(Inset, { children: [_jsx(StyledTitle, __assign({ as: "h3", size: "medium", weight: "bold" }, { children: heading })), _jsx(Stack, { size: "small" }), _jsx(StyledText, __assign({ size: "regular" }, { children: text })), _jsx(Stack, { size: "medium" }), _jsx(Button, __assign({ buttonType: "primary", onClick: onClick, "data-reason": button, "data-type": buttonAnalytics === null || buttonAnalytics === void 0 ? void 0 : buttonAnalytics.dataType, "data-object": buttonAnalytics === null || buttonAnalytics === void 0 ? void 0 : buttonAnalytics.dataObject, "data-analytics": buttonAnalytics === null || buttonAnalytics === void 0 ? void 0 : buttonAnalytics.dataAnalytics }, { children: button }))] }) }), _jsx(Stack, {})] }) })));
};
export default OptionCard;
//# sourceMappingURL=index.js.map